import createIcon from '../../createIcon';

/**
 * @component @name LocalConvenienceStore
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgN1Y0SDVWN0gyVjIwSDEwVjE2SDE0VjIwSDIyVjdIMTlaTTExIDEwSDlWMTFIMTFWMTJIOFY5SDEwVjhIOFY3SDExVjEwWk0xNiAxMkgxNVYxMEgxM1Y3SDE0VjlIMTVWN0gxNlYxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalConvenienceStore = createIcon('LocalConvenienceStore', [
  [
    'path',
    {
      d: 'M19 7V4H5V7H2V20H10V16H14V20H22V7H19ZM11 10H9V11H11V12H8V9H10V8H8V7H11V10ZM16 12H15V10H13V7H14V9H15V7H16V12Z',
      key: '49lmu0',
    },
  ],
]);

export default LocalConvenienceStore;
